import React from "react";
import { Subscribe } from "unstated";
import { t } from "@lingui/macro";
// Our modules
import { store } from "../../stores/Main";
import { GroupsList, Section } from "../../components";
import { i18n } from "idc-ui-react";

function GroupsPage({ store }) {
  const { rolegroups } = store.state.loggedInUser;

  return (
    <Section hero returnLink text={i18n._(t`All Business Roles`)}>
      {!rolegroups ? (
        <div>{i18n._(t`No Business Roles assigned yet!`)}</div>
      ) : (
        <GroupsList rolegroups={rolegroups} />
      )}
    </Section>
  );
}

const StoreWrapper = () => (
  <Subscribe to={[store]}>{store => <GroupsPage store={store} />}</Subscribe>
);

export default StoreWrapper;
